import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Button, Col, Row } from "reactstrap";
import { Field, InjectedFormProps, getFormValues, reduxForm } from "redux-form";
import FutureDatepicker from "../../../commonfields/FutureDatePicker";
import SelectField from "../../../commonfields/SelectField";
import TextField from "../../../commonfields/TextField";
import stateNames from "../../../data/stateNames.json";
import FileUpload from "../../../commonfields/FileUpload";
import SelectButtonField2 from "../../../commonfields/SelectButtonField2";
import { fileFormats, textFormatter } from "../../../utils/GeneralUtils";
import validate from "./NewLead/Validate";
import { AxiosError, AxiosResponse } from "axios";
import { catchError } from "../../../utils/Utils";
import Service from "../../../services";
import FinSpinner from "../../../commonfields/FinSpinner";

interface IActionItemsFormProps {
  handleActionItemSave: (values: FormData) => void;
  InitialValues?: object;
}

const ActionItemForm: React.FC<
  any & InjectedFormProps<Record<string, unknown>, any>
> = (props: any) => {
  const { handleActionItemSave, defaultProduct, defaultContact, disableField, assignActionToData, defaultAssigneeActionToData, loader } =
    props;

  const actionsItemsStatus = [
    {
      id: 0,
      text: "Mark as Done",
      value: "Completed",
    },
    {
      id: 1,
      text: "Cancel Action Item",
      value: "Canceled",
    },
  ];

  return (
    <>
      {loader && <FinSpinner />}
      <form
        onSubmit={props.handleSubmit(handleActionItemSave)}
        className="actionItemForm"
      >
        {" "}
        <div className="actionItemContainer container">
          <Row className="action-row">
            <Col md={8}>
              <Field
                component={TextField}
                name="action"
                label={"Action"}
                isRequired
                maxlength={60}
              />
            </Col>
            <Col md={4}>
              <Field
                component={SelectField}
                name="product"
                label={"Product"}
                values={props.productsData || []}
                // defaultValue={defaultProduct}
                disabled={disableField}
                isRequired
              />
            </Col>
          </Row>

          <Row className="second-row">
            <Col md={4} className="contact">
              <Field
                component={SelectField}
                name="contact"
                label={"Contact"}
                values={props.contactsData || []}
                // defaultValue={defaultContact}
                disabled={disableField}
                isRequired
                optionLength={18}
              />
            </Col>
            <Col md={4}>
              <Field
                component={SelectField}
                name="interaction"
                label={"Interaction"}
                values={props.interactionData || []}
                isRequired
              />
            </Col>
            <Col
              md={4}
              className="nextAction actionTab"
              style={{ position: "relative" }}
            >
              <label>
                Next Action <span className="nextActionLabel">*</span>
              </label>
              <Field
                component={FutureDatepicker}
                name="nextActionDate"
                minDate={new Date()}
                isValidation={true}
                isRequired
              />
            </Col>
          </Row>
          {props.edit && (
            <Row className="editActionItemStatusContainer">
              <Col md={3}>
                <div className="creationDateContainer">
                  <p className="creationDatelabel">Creation Date</p>
                  <p className="creationDateText">
                    {textFormatter(props?.createdDate)}
                  </p>
                </div>
              </Col>
              <Col md={7} className="markbutton-wrap">
                <Field
                  component={SelectButtonField2}
                  name="actionsItemsStatus"
                  label={""}
                  values={actionsItemsStatus}
                />
              </Col>
            </Row>
          )}
          <Row>
            <Col
              md={6}
              className="assingnActionTo"
            >
              <Field
                component={SelectField}
                name="assignActionTo"
                label={"Assign Action Item To"}
                values={assignActionToData || []}
                // defaultValue={defaultAssigneeActionToData}
                isRequired
              />
            </Col>
          </Row>
          <Row className="third-row">
            <Col md={12} className="notesData">
              <Field
                component={TextField}
                type="textarea"
                name="notes"
                label={"Notes"}
                optional={true}
              />
            </Col>
          </Row>
          <Row>
            <div className="documentName">
              <Col md={12}>
                <Field
                  component={FileUpload}
                  onHandleClick={props?.openFileViwer}
                  onRemoveClick={props?.removeFile}
                  acceptedFormats={fileFormats}
                  displayAccepedFormats={false}
                  noClick={false}
                  noDrag={false}
                  name="documentTemplate"
                  label={"Documents"}
                  maxSize={20 * 1024 * 1024}
                  disabled={false}
                  showFilesList={true}
                  optional={true}
                />
              </Col>
            </div>
          </Row>
        </div>
        <div className="submit-btn">
          <Button color="primary-color" disabled={props.invalid}>
            Save
          </Button>
        </div>
      </form>
    </>
  );
};

const mapStateToProps = (state: any, props: any) => {
  return {
    initialValues: props.initialData,
    formValues: getFormValues("ActionItemForm")(state),
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "ActionItemForm", // a unique identifier for this form
    enableReinitialize: true,
    touchOnChange: true,
    validate,
  })(ActionItemForm)
);
